import { ISystemConfig } from './types';

import axiosInstance from 'services/common/instance';

// eslint-disable-next-line import/prefer-default-export
export const apiGetSystemConfig = async (): Promise<ISystemConfig> => {
  const res = await axiosInstance.get('api/v1/system-config');
  return res.data.data;
};
